// src/pages/AuthPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShoppingBag } from 'react-icons/fa';
import '../../../../assets/css/customer/auth/Profile.css';
import BottomNavigation from '../../../../components/general/bottomnavigation/BottomNavigation';

const AuthPage = () => {
  const navigate = useNavigate();

  const handlePasswordLogin = (e) => {
    e.preventDefault();
    console.log('Password login');
    navigate('/account');
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    console.log('Sign up');
    navigate('/account');
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleSignUpClick = () => {
    navigate('/signup');
  };

  return (
    <div className="auth-container">
      {/* Animated Background Circles */}
      <div className="background-circles">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
        <div className="circle circle-4"></div>
      </div>

      <div className="auth-card">
        {/* Brand Section */}
        <div className="auth-logo-section">
          <h1 className="auth-brand">CraftHive</h1>
          <p className="auth-tagline">Unique pieces, made just for you</p>
        </div>

        {/* Info Strip */}
        <div className="auth-info-strip">
          <FaShoppingBag className="auth-info-icon" />
          <p className="auth-info-text">Ready to explore something special?</p>
        </div>

        {/* Login/Signup Tabs */}
        <div className="auth-tabs">
          <button className="auth-tab" onClick={handleLoginClick}>
            Login
          </button>
          <button className="auth-tab" onClick={handleSignUpClick}>
            Signup
          </button>
        </div>
      </div>
      <BottomNavigation />
    </div>
  );
};

export default AuthPage;